module.exports = __webpack_public_path__ + "static/07-23c4eeb2cf27af20e407f02d3926b06f.jpg";